module.exports = __webpack_public_path__ + "img/quizmayhem_banner_usa.2f5be3da.jpg";